module.exports = __webpack_public_path__ + "static/media/embed_type_interactive.b1590139.svg";